import React from 'react'
import PageLayout from '../../layout/page_layout'
import Container from '../../components/container'
import { Tab, Tabs } from '@mui/material'
import BookingRequestedByMeList from './requested_by_me'
import Box from '../../components/box'
import BookingHostedByMeList from './hosted_be_me'

enum TabName {
  REQUESTED_BY_ME = 'REQUESTED_BY_ME',
  HOSTED_BY_ME = 'HOSTED_BY_ME'
}

const BookingPage: React.FC = () => {
  const [currentTab, setCurrentTab] = React.useState<TabName>(TabName.REQUESTED_BY_ME)

  return (
    <PageLayout authOnly>
      <Tabs
          value={currentTab}
          onChange={(_, newValue) => {
            setCurrentTab(newValue)
          }}
          variant='fullWidth'
          textColor="secondary"
          indicatorColor="primary"
          aria-label="secondary tabs example"
        >
        <Tab value={TabName.REQUESTED_BY_ME} label="Requested By Me" />
        <Tab value={TabName.HOSTED_BY_ME} label="Hosted By Me" />
      </Tabs>
      <Container>
        <Box hidden={currentTab !== TabName.REQUESTED_BY_ME}>
          <BookingRequestedByMeList />
        </Box>
        <Box hidden={currentTab !== TabName.HOSTED_BY_ME}>
          <BookingHostedByMeList />
        </Box>
      </Container>
    </PageLayout>
  )
}

export default BookingPage
